import React from 'react';
import { Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import { withStyles} from '@material-ui/core/styles';
import './businessheroes.css';
import dominosLogo from './assets/Dom.png';
import oreoLogo from './assets/Oreo.png';
import cokeLogo from './assets/Frito.png';
import jackLogo from './assets/Jack.png';
import logo from './assets/taskforce-logo.png';


const styles = {
    root: {
      background: 'transparent',
      borderRadius: 0,
      border: 0,
      color: 'white',
      height: 200,
      width: 200,
      padding: '0px 80px',
      margin: 20,
    },
  };

function Heroes(props) {
    const { classes, children, className, ...other } = props;
    return (
    <div className="Heroes">
        <h1>
            Business Heroes
        </h1>
        <h2>
            A preparedness messaging system
        </h2>
        <Box textAlign='center' className='heroBox'>
            <div>
                <Button className={clsx(classes.root, className)} {...other} variant="contained" href="https://jesus-canez.firebaseapp.com/arTarget.html">
                    <img className="dominosLogo" src={ dominosLogo } alt="dominosLogo" height="500%" width="500%"/>
                </Button>
                <Button className={clsx(classes.root, className)}  variant="contained"  href="/businessheroes/oreo">
                    <img className="oreoLogo" src={ oreoLogo } alt="oreoLogo" height="400%" width="400%"/>
                </Button>
            </div>
            <div>
                <Button className={clsx(classes.root, className)} {...other} variant="contained" href="/businessheroes/coke" >
                    <img className="cokeLogo" src={ cokeLogo } alt="cokeLogo" height="300%" width="300%"/>
                </Button>
                <Button className={clsx(classes.root, className)} {...other} variant="contained"  href="/businessheroes/jackdaniels" >
                    <img className="jackLogo" src={ jackLogo } alt="jackLogo" height="400%" width="400%"/>
                </Button>
            </div>
        </Box>


      <img className="logo2" src={ logo } alt="logo2"/>

    </div>
    );
}

export default withStyles(styles)(Heroes);

